import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  useParams,
} from 'react-router-dom'
import { ReactAppEnv } from 'apiConfig'
import { Home, Dashboard, NotificationPage } from 'pages'
import SearchResults from '../App/globalSearch/pages/SearchResultsPage'
import { NegotiatorMFE, SparkMFE, TileMFE } from 'mfes'
import TeamsListPage from 'teams/pages/TeamsListPage'
import TeamsViewPage from 'teams/pages/TeamsViewPage'
import UsersSearchPage from 'users/pages/UserSearchPage'
import TeamsCreatePage from 'teams/pages/TeamCreatePage'
import { AccountSettingsPage } from 'account/pages/AccountSettings'
import WorkspaceViewTabs from 'workspaces/components/WorkspaceViewTabs'
import { TileBoardsMFE } from 'mfes/TileBoardsMFE'
import Reporting from 'pages/Reporting'
import DownloadPage from 'pages/Download/DownloadPage'
import SplashRouteGate from './SplashRouteGate'
interface RouteVisibility {
  isInternal: boolean
  isPackagingSupplier: boolean
  isFabricSupplier: boolean
  isTrimSupplier: boolean
  isAdmin: boolean
  canImpersonate: boolean
  sparkUser?: any
}

function InsightsRedirect() {
  const { '*': splat } = useParams()
  return <Navigate to={`/reporting/${splat ?? ''}`} replace />
}

export const createRouter = (
  environment: ReactAppEnv,
  Layout: React.FC<unknown & { children?: JSX.Element }>,
  {
    isInternal,
    isPackagingSupplier,
    isFabricSupplier,
    isTrimSupplier,
    isAdmin,
    canImpersonate,
    sparkUser,
  }: RouteVisibility,
) => {
  return createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<SplashRouteGate Layout={Layout} />}>
        <Route index element={<Home />} />
        <Route path="download" element={<DownloadPage />} />
        <Route path="notifications" element={<NotificationPage />} />
        <Route path="searchResults">
          <Route index element={<SearchResults />} />
          <Route path=":searchTerm" element={<SearchResults />} />
        </Route>
        <Route path="reporting">
          <Route index element={<Reporting isInternal={isInternal} />} />
          <Route
            path="*"
            element={
              <SparkMFE
                key={'insights/*'}
                route="insights"
                environment={environment}
              />
            }
          />
        </Route>
        <Route path="insights">
          <Route path="*" element={<InsightsRedirect />} />
        </Route>

        <Route path="dashboard">
          <Route index element={<Dashboard />} />
          <Route path="*" element={<Dashboard />} />
        </Route>
        <Route path="account">
          <Route index element={<AccountSettingsPage />} />
          <Route path="*" element={<AccountSettingsPage />} />
        </Route>
        {!isPackagingSupplier && (
          <Route path="teams">
            <Route index element={<TeamsListPage />} />
            <Route path="create" element={<TeamsCreatePage />} />
            <Route path=":teamId" element={<TeamsViewPage />} />
          </Route>
        )}
        {!isPackagingSupplier && (
          <Route path="users">
            <Route index element={<UsersSearchPage />} />
          </Route>
        )}
        {!isTrimSupplier && !isPackagingSupplier && (
          <Route path="workspaces">
            <Route
              index
              element={
                <SparkMFE
                  key="workspaces"
                  route="workspaces"
                  environment={environment}
                  componentsFromContainer={{
                    PLMWorkspaceTabs: WorkspaceViewTabs,
                  }}
                />
              }
            />
            <Route
              path=":workspaceId/boards/*"
              element={<TileBoardsMFE environment={environment} />}
            />
            <Route
              path="*"
              element={
                <SparkMFE
                  key="workspaces/*"
                  route="workspaces"
                  environment={environment}
                  componentsFromContainer={{
                    PLMWorkspaceTabs: WorkspaceViewTabs,
                  }}
                />
              }
            />
          </Route>
        )}
        {!isFabricSupplier && !isTrimSupplier && !isPackagingSupplier && (
          <Route path="products">
            <Route
              index
              element={
                <SparkMFE
                  key="products"
                  route="products"
                  environment={environment}
                />
              }
            />
            <Route
              path="*"
              element={
                <SparkMFE
                  key="products/*"
                  route="products"
                  environment={environment}
                />
              }
            />
          </Route>
        )}
        {!isFabricSupplier && !isTrimSupplier && !isPackagingSupplier && (
          <Route path="productComponents">
            <Route
              index
              element={
                <SparkMFE
                  key="productComponents"
                  route="productComponents"
                  environment={environment}
                />
              }
            />
            <Route
              path="*"
              element={
                <SparkMFE
                  key="productComponents/*"
                  route="productComponents"
                  environment={environment}
                />
              }
            />
          </Route>
        )}
        {!isPackagingSupplier && (
          <Route path="templateLibrary">
            <Route
              index
              element={
                <SparkMFE
                  key="templateLibrary"
                  route="templateLibrary"
                  environment={environment}
                />
              }
            />
            <Route
              path="*"
              element={
                <SparkMFE
                  key="templateLibrary/*"
                  route="templateLibrary"
                  environment={environment}
                />
              }
            />
          </Route>
        )}
        {!isFabricSupplier && !isTrimSupplier && !isPackagingSupplier && (
          <Route path="measurements">
            <Route
              index
              element={
                <SparkMFE
                  key="measurements"
                  route="measurements"
                  environment={environment}
                />
              }
            />
            <Route
              path="*"
              element={
                <SparkMFE
                  key="measurements/*"
                  route="measurements"
                  environment={environment}
                />
              }
            />
          </Route>
        )}
        {!isFabricSupplier && !isTrimSupplier && !isPackagingSupplier && (
          <Route path="productDetails">
            <Route
              index
              element={
                <SparkMFE
                  key="productDetails"
                  route="productDetails"
                  environment={environment}
                />
              }
            />
            <Route
              path="*"
              element={
                <SparkMFE
                  key="productDetails/*"
                  route="productDetails"
                  environment={environment}
                />
              }
            />
          </Route>
        )}
        <Route path="resourceRedirect">
          <Route
            index
            element={
              <SparkMFE
                key="resourceRedirect"
                route="resourceRedirect"
                environment={environment}
              />
            }
          />
          <Route
            path="*"
            element={
              <SparkMFE
                key="resourceRedirect/*"
                route="resourceRedirect"
                environment={environment}
              />
            }
          />
        </Route>
        <Route path="fileLibrary">
          <Route
            index
            element={
              <SparkMFE
                key="fileLibrary"
                route="fileLibrary"
                environment={environment}
              />
            }
          />
          <Route
            path="*"
            element={
              <SparkMFE
                key="fileLibrary/*"
                route="fileLibrary"
                environment={environment}
              />
            }
          />
        </Route>
        {!isPackagingSupplier && (
          <Route path="materials">
            <Route
              index
              element={
                <SparkMFE
                  key="materials"
                  route="materials"
                  environment={environment}
                />
              }
            />
            <Route
              path="*"
              element={
                <SparkMFE
                  key="materials/*"
                  route="materials"
                  environment={environment}
                />
              }
            />
          </Route>
        )}
        {!isPackagingSupplier && (
          <Route path="bulkAddToPalette">
            <Route
              index
              element={
                <SparkMFE
                  key="bulkAddToPalette"
                  route="bulkAddToPalette"
                  environment={environment}
                />
              }
            />
            <Route
              path="*"
              element={
                <SparkMFE
                  key="bulkAddToPalette/*"
                  route="bulkAddToPalette"
                  environment={environment}
                />
              }
            />
          </Route>
        )}
        {!isPackagingSupplier && (
          <Route path="bulkUpdateFabricSpecifications">
            <Route
              index
              element={
                <SparkMFE
                  key="bulkUpdateFabricSpecifications"
                  route="bulkUpdateFabricSpecifications"
                  environment={environment}
                />
              }
            />
            <Route
              path="*"
              element={
                <SparkMFE
                  key="bulkUpdateFabricSpecifications/*"
                  route="bulkUpdateFabricSpecifications"
                  environment={environment}
                />
              }
            />
          </Route>
        )}
        {!isPackagingSupplier && (
          <Route path="palettes">
            <Route
              index
              element={
                <SparkMFE
                  key="palettes"
                  route="palettes"
                  environment={environment}
                />
              }
            />
            <Route
              path="*"
              element={
                <SparkMFE
                  key="palettes/*"
                  route="palettes"
                  environment={environment}
                />
              }
            />
          </Route>
        )}
        {!isTrimSupplier && !isPackagingSupplier && (
          <Route path="combinations">
            <Route
              index
              element={
                <SparkMFE
                  key="combinations"
                  route="combinations"
                  environment={environment}
                />
              }
            />
            <Route
              path="*"
              element={
                <SparkMFE
                  key="combinations/*"
                  route="combinations"
                  environment={environment}
                />
              }
            />
          </Route>
        )}
        {isInternal && (
          <Route path="rfid">
            <Route
              index
              element={
                <SparkMFE key="rfid" route="rfid" environment={environment} />
              }
            />
            <Route
              path="*"
              element={
                <SparkMFE key="rfid/*" route="rfid" environment={environment} />
              }
            />
          </Route>
        )}
        <Route path="resources">
          <Route
            index
            element={
              <SparkMFE
                key="resources"
                route="resources"
                environment={environment}
              />
            }
          />
          <Route
            path="*"
            element={
              <SparkMFE
                key="resources/*"
                route="resources"
                environment={environment}
              />
            }
          />
        </Route>
        {isInternal && (
          <Route path="admin">
            <Route path="rules">
              <Route
                index
                element={
                  <SparkMFE
                    key="rules"
                    route="rules"
                    environment={environment}
                  />
                }
              />
              <Route
                path="*"
                element={
                  <SparkMFE
                    key="rules/*"
                    route="rules"
                    environment={environment}
                  />
                }
              />
            </Route>
            <Route path="tags">
              <Route
                index
                element={
                  <SparkMFE key="tags" route="tags" environment={environment} />
                }
              />
              <Route
                path="*"
                element={
                  <SparkMFE
                    key="tags/*"
                    route="tags"
                    environment={environment}
                  />
                }
              />
            </Route>
            <Route path="materialTypes">
              <Route
                index
                element={
                  <SparkMFE
                    key="materialTypes"
                    route="materialTypes"
                    environment={environment}
                  />
                }
              />
              <Route
                path="*"
                element={
                  <SparkMFE
                    key="materialTypes/*"
                    route="materialTypes"
                    environment={environment}
                  />
                }
              />
            </Route>
            <Route path="vendorMerge">
              <Route
                index
                element={
                  <SparkMFE
                    key="vendorMerge"
                    route="vendorMerge"
                    environment={environment}
                  />
                }
              />
              <Route
                path="*"
                element={
                  <SparkMFE
                    key="vendorMerge/*"
                    route="vendorMerge"
                    environment={environment}
                  />
                }
              />
            </Route>
            <Route path="accessGroups">
              <Route
                index
                element={
                  <SparkMFE
                    key="accessGroups"
                    route="accessGroups"
                    environment={environment}
                  />
                }
              />
              <Route
                path="*"
                element={
                  <SparkMFE
                    key="accessGroups/*"
                    route="accessGroups"
                    environment={environment}
                  />
                }
              />
            </Route>
          </Route>
        )}
        {isInternal && canImpersonate && isAdmin && (
          <Route path="ui">
            <Route path="admin">
              <Route
                index
                element={
                  <SparkMFE
                    key="uiAdmin"
                    route="uiAdmin"
                    environment={environment}
                  />
                }
              />
              <Route
                path="*"
                element={
                  <SparkMFE
                    key="uiAdmin/*"
                    route="uiAdmin"
                    environment={environment}
                  />
                }
              />
            </Route>
          </Route>
        )}
        <Route path="events">
          <Route
            index
            path="*"
            element={
              <NegotiatorMFE
                environment={environment}
                module="./EventsRouting"
              />
            }
          />
        </Route>
        <Route path="libraries">
          <Route
            path="*"
            element={
              <NegotiatorMFE
                environment={environment}
                module="./LibraryRouting"
              />
            }
          />
        </Route>
        <Route path="tile/*" element={<TileMFE environment={environment} />} />
      </Route>,
    ),
  )
}
